import all from 'it-all';
/**
 * Collects all values from an async iterator, sorts them
 * using the passed function and yields them
 */
export default async function* sort(source, sorter) {
    const arr = await all(source);
    yield* arr.sort(sorter);
}
